<template>
  <div style="width: 100%;">
    <div v-if="this.activeParent == 'men'">
      <div v-if="this.activeTab == 'g'">
        <img src="../../../assets/corporate-competition/corporate-competition-2024-schedule-men-group-1.jpg" />
        <img src="../../../assets/corporate-competition/corporate-competition-2024-schedule-men-group-2.jpg" />
      </div>
      <div v-else-if="this.activeTab == 's'">
        <img src="../../../assets/corporate-competition/corporate-competition-2024-schedule-men-group-semi-finals-1.jpg" />
        <img src="../../../assets/corporate-competition/corporate-competition-2024-schedule-men-group-semi-finals-2.jpg" />
      </div>
      <div v-else-if="this.activeTab == 'f'">
        <!-- <h5 class="no-data">COMING SOON</h5> -->
        <img src="../../../assets/corporate-competition/corporate-competition-2024-schedule-men-finals-1.png" />
        <img src="../../../assets/corporate-competition/corporate-competition-2024-schedule-men-finals-2.png" />
      </div>
    </div>
    <div v-else-if="this.activeParent == 'open'">
      <div v-if="this.activeTab == 'g'">
        <img src="../../../assets/corporate-competition/enterprise-competition-2024-schedule-open-group-1.jpg" />
        <img src="../../../assets/corporate-competition/enterprise-competition-2024-schedule-open-group-2.jpg" />
      </div>
      <div v-else-if="this.activeTab == 's'">
        <img src="../../../assets/corporate-competition/enterprise-competition-2024-schedule-open-group-semi-finals-1.jpg" />
      </div>
      <div v-else-if="this.activeTab == 'f'">
        <!-- <h5 class="no-data">COMING SOON</h5> -->
        <img src="../../../assets/corporate-competition/corporate-competition-2024-schedule-open-group-finals.png" />
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    activeTab: String,
    activeParent: String,
  },
  data() {
    return {
    };
  },
  watch: {
    activeTab() {
      console.log("🚀 ~ mounted ~ this.activeTab:", this.activeTab)
    },
    activeParent() {
      console.log("🚀 ~ mounted ~ this.activeParent:", this.activeParent)
    },
  },
};
</script>

<style lang="scss">
.tab-content {
  display: flex;
  justify-content: space-around;
  border-bottom: 2px solid #c5cfe348;

  .play-box {
    height: 100px;
    margin: 10px;
    padding-top: 10px;
  }

  .play-time,
  .play-tit {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 25px;
    width: 20%;
    color: #2d3b51;
  }

  .play-team1,
  .play-team2,
  venue {
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;

    // padding-top: 30px;
    .play-txt1 {
      //   width: 33.3%;
      text-align: right;

      // padding: 10px;
      .sp1 {
        color: #5aa2d3;
      }

      .sp2 {
        font-size: 18px;
        font-weight: 600;
        color: #2d3b51;
      }
    }

    .play-txt2 {
      width: 33.3%;
      margin: 0 20px;
      margin-top: -10px;

      img {
        border-radius: 10px;
      }
    }

    .play-txt3 {
      width: 33.3%;
      font-size: 30px;
      font-weight: 600;
      color: #c2cfe5;
    }
  }
}
</style>
